import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreateOrganizationApiKeyRequestDto } from '@domain/organization-api-key/dtos/create-organization-api-key.request.dto';
import { ListOrganizationApiKeyRequestDto } from '@domain/organization-api-key/dtos/list-organization-api-key.request.dto';
import { OrganizationApiKeyResponseDto } from '@domain/organization-api-key/dtos/organization-api-key.response.dto';

@Injectable({
  providedIn: 'root',
})
export class OrganizationApiKeyService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('organization-api-key');
  }

  list(request: ListOrganizationApiKeyRequestDto) {
    const { companyRefId } = request;
    const queryUrl = `${this.getApiUrl()}/list/${companyRefId}`;
    return this.http.get<ApiResponse<OrganizationApiKeyResponseDto[]>>(
      queryUrl,
    );
  }

  create(request: CreateOrganizationApiKeyRequestDto) {
    const queryUrl = `${this.getApiUrl()}`;
    return this.http.post<ApiResponse<OrganizationApiKeyResponseDto>>(
      queryUrl,
      request,
    );
  }

  revoke(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/revoke/${refId}`;
    return this.http.patch<ApiResponse<OrganizationApiKeyResponseDto>>(
      queryUrl,
      {},
    );
  }
}
